// @ts-ignore
/* eslint-disable */
import request from "../../utils/request";

/** 校验用户的测评次数 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /new-evaluation/evaluation/check-count */
export async function newEvaluationEvaluationCheckCountUsingPOST(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResultCheckEvaluationCountResp>(
    "/new-evaluation/evaluation/check-count",
    {
      method: "POST",
      ...(options || {}),
    }
  );
}

/** 提交客户评估 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /new-evaluation/evaluation/finish */
export async function newEvaluationEvaluationFinishUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newEvaluationEvaluationFinishUsingPOSTParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/new-evaluation/evaluation/finish", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户的测评信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /new-evaluation/evaluation/info */
export async function newEvaluationEvaluationInfoUsingGET(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResultNewEvaluateInfoResp>(
    "/new-evaluation/evaluation/info",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 重新测评 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /new-evaluation/evaluation/redo */
export async function newEvaluationEvaluationRedoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newEvaluationEvaluationRedoUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/new-evaluation/evaluation/redo", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建测评 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /new-evaluation/evaluation/start */
export async function newEvaluationEvaluationStartUsingPOST(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResultStartOrRedoEvaluationResp>(
    "/new-evaluation/evaluation/start",
    {
      method: "POST",
      ...(options || {}),
    }
  );
}

/** 获取客户评估基本信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /new-evaluation/profile/info */
export async function newEvaluationProfileInfoUsingGET(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResultProfileInfoResp>(
    "/new-evaluation/profile/info",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 提交客户评估基本信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /new-evaluation/profile/submit */
export async function newEvaluationProfileSubmitUsingPOST(
  body: API.SubmitProfileReq,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/new-evaluation/profile/submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取测评的答案选项 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /new-evaluation/survey/answer-info */
export async function newEvaluationSurveyAnswerInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newEvaluationSurveyAnswerInfoUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultSurveyAnswerInfoResp>(
    "/new-evaluation/survey/answer-info",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 保存测评选项 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /new-evaluation/survey/submit-answer */
export async function newEvaluationSurveySubmitAnswerUsingPOST(
  body: API.SubmitSurveyAnswerReq,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/new-evaluation/survey/submit-answer", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取题目列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /new-evaluation/survey/topic-list */
export async function newEvaluationSurveyTopicListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newEvaluationSurveyTopicListUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultListEvaluationTopicInfoResp>(
    "/new-evaluation/survey/topic-list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 获取人脸识别结果 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /new-evaluation/verify/face-verify/result */
export async function newEvaluationVerifyFaceVerifyResultUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newEvaluationVerifyFaceVerifyResultUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultFaceVerifyResultResp>(
    "/new-evaluation/verify/face-verify/result",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 获取用户的认证信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /new-evaluation/verify/info */
export async function newEvaluationVerifyInfoUsingGET(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResultVerifyInfoResp>("/new-evaluation/verify/info", {
    method: "GET",
    ...(options || {}),
  });
}

/** 重新认证 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /new-evaluation/verify/redo */
export async function newEvaluationVerifyRedoUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newEvaluationVerifyRedoUsingPOSTParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/new-evaluation/verify/redo", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建认证 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /new-evaluation/verify/start */
export async function newEvaluationVerifyStartUsingGET(options?: {
  [key: string]: any;
}) {
  return request<API.BaseResultCreateVerifyResp>(
    "/new-evaluation/verify/start",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 提交签字人脸识别认证 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /new-evaluation/verify/submit-esign-face */
export async function newEvaluationVerifySubmitEsignFaceUsingPOST(
  body: API.CreateFaceAuthReq,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultFaceAuthResp>(
    "/new-evaluation/verify/submit-esign-face",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 三要素身份证校验 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /new-evaluation/verify/submit-id */
export async function newEvaluationVerifySubmitIdUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newEvaluationVerifySubmitIdUsingPOSTParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/new-evaluation/verify/submit-id", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 其他身份校验 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /new-evaluation/verify/submit-other */
export async function newEvaluationVerifySubmitOtherUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.newEvaluationVerifySubmitOtherUsingPOSTParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultVoid>("/new-evaluation/verify/submit-other", {
    method: "POST",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
